export const shopModule = {
  namespaced: true,
  state: {
    view: "cart",
    cart: [],
    shipping: null,
    email: null
  },
  getters: {
    totalAmount: state => {
      let amount = 0;
      state.cart.forEach(item => (amount += item.price * item.quantity));
      if (state.shipping) {
        amount += state.shipping.amount / 100;
      }
      return amount;
    },
    weightTotal: (state) => {
      let amount = 0;
      state.cart.forEach((item) => (amount += item.shipping_weight * item.quantity));
      return amount;
    },
  },
  mutations: {
    addToCart({ cart }, product) {
      const itemIndex = cart.findIndex(item => item.id === product.id);
      if (itemIndex < 0) {
        cart.push(product);
      } else {
        cart[itemIndex].quantity++;
      }
    },
    removeFromCart({ cart }, productid) {
      const itemIndex = cart.findIndex(item => item.id === productid);
      cart.splice(itemIndex, 1);
    },
    decreaseItem({ cart }, productid) {
      const itemIndex = cart.findIndex(item => item.id === productid);
      cart[itemIndex].quantity--;
    },
    increaseItem({ cart }, productid) {
      const itemIndex = cart.findIndex(item => item.id === productid);
      cart[itemIndex].quantity++;
    }
  }
};
